module.exports = __webpack_public_path__ + "img/sem-multa-4.02c292c2.svg";